import { Component, Input } from '@angular/core';
import { Dependent } from '../../../user/models/user-profile.model';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { UserService } from '../../../user/services/user.service';
import { RequestsService } from '../services/requests.service';
import { LoaderService } from '../../../../shared/services/loader.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Specialty } from '../../../user/models/user-update.model';

@Component({
  selector: 'app-medical',
  imports: [CommonModule, FormsModule, MatIconModule, MatRadioModule, MatSelectModule, MatFormFieldModule],
  templateUrl: './medical.component.html',
  styleUrl: './medical.component.scss'
})
export class MedicalComponent {

  @Input() nameService: string = '';

  dependent: Dependent[] = [];
  nameOwner: string = '';
  phoneOwner: string = '';
  keyOwner: string = '';
  selectedPatient = 'titular';
  contactoDeTelefono: String = '0';
  selectedSpecialty: string = '';
  specialties: { id: number; name: string }[] = [];
  idProduct: number = 0;

  constructor(private router: Router, private route: ActivatedRoute, 
    private userService: UserService, private requestServ: RequestsService, 
    private loader: LoaderService) { }

  ngOnInit():void{
    this.getDetailUser();
    this.initializeProductId();
    this.getServiceContact();
  }

initializeProductId(): void {
  const accountData = localStorage.getItem('account');
  if (!accountData) return; 

  const accountId = Number(accountData);
  if (isNaN(accountId)) return; 

  this.idProduct = accountId;
  this.loadSpecialties(this.idProduct);
}

  getDetailUser() {
    const userData = localStorage.getItem('user');
    if (userData) {
      const userObj = JSON.parse(userData);
      this.nameOwner = userObj.name || '';
      this.phoneOwner = userObj.phone || '';
      this.keyOwner = userObj.memberships || '';
    }

    const cognitoId = localStorage.getItem('cognito');
    if (cognitoId) {
      this.userService.getUserProfile(cognitoId).subscribe({
        next: (res) => {
          this.dependent = res.dependents;
        },
        error: (err) => console.error('Error al obtener perfil', err)
      });
    }
  }


 loadSpecialties(idProduct: number): void {
  this.loader.show();
  this.userService.getSpecialitys(idProduct).subscribe({
    next: (res) => {
      this.loader.hide();
      if (res?.code === 200 && res?.data?.length) {
        this.specialties = res.data.map((item: Specialty) => ({
          id: item.id,
          name: item.specialtyName
        }));
      } else {
        this.specialties = [];
      }
    },
    error: (err) => {
      this.loader.hide();
      console.error('Error al obtener especialidades:', err);
      this.specialties = [];
    }
  });
}

  confirm():void{
    this.generateExpediente();
  }

  generateExpediente() {
    const solicitudData = localStorage.getItem('solicitudData');
    let servicio;
    
    if (solicitudData) {
      servicio = JSON.parse(solicitudData).servicio;
    } else {
      const params = this.route.snapshot.queryParams;
      servicio = {
        clServicio: params['clServicio'] || 6,
        clSubservicio: params['clSubServicio'] || 383,
        dsServicio: params['dsServicio'] || 'Asistencia Médica',
        dsSubServicio: params['dsSubServicio'] || 'Consulta Médica en Consultorio'
      };
    }
    
    this.loader.show();
    
    const selectedName = this.selectedPatient === 'titular' ? this.nameOwner : this.selectedPatient;
    const { firstName, lastName, secondLastName } = this.splitFullName(selectedName);
    
    const accountData = localStorage.getItem('account');
    const accountId = accountData ? JSON.parse(accountData) : 536;
    
    const payload = {
      identifier: {
        tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
        app: 'PortalAsistencia'
      },
      petition: {
        serviceId: servicio.clServicio,
        subServiceId: servicio.clSubservicio.toString(),
        hasAssistance: false,
        key: this.keyOwner,
        areaCode1: '044',
        phone1: this.phoneOwner,
        stateCode: '',
        municipalityCode: '',
        statusId: 0,
        accountId: accountId,
        appUserId: 1,
        countryId: 115,
        contactTypeId: 15,
        serviceTypeId: 1,
        sendCharge: false,
        hasAppointment: false,
        isRelevant: false,
        gender: 1,
        isOk: true,
        hasQuotation: false,
        isSise2: true,
        serviceReceptionId: 10,
        personId: 1,
        username: this.nameOwner,
        paternalSurname: '',
        userSecondLastName: '',
        contactName: selectedName,
        userFirstNamePf: firstName,
        userLastNamePf: lastName,
        userSecondLastNamePf: secondLastName,
        ourUser: this.nameOwner,
        externalCabRepName: 'API CLIENTES',
        folio: crypto.randomUUID(),
        longitude: '', // Vacío
        latitude: '', // Vacío
        incidentDescription: this.selectedSpecialty,
        clRecepcionServicio: 10,
        infoadicional: this.selectedSpecialty
      }
    };

    this.requestServ.sendMedicaTelefonicaRequest(payload).subscribe({
      next: (res) => {
        this.loader.hide();
        console.log('Expediente generado:', res);
        
        const expediente = res?.response?.id || res?.data?.clExpediente || res?.clExpediente;
        
        const assistanceData = {
          clave: res.response.clave || '',
          clexpediente: expediente,
          nuestrousuario: res.response.nuestrousuario || this.nameOwner,
          clcuenta: res.response.clcuenta || '',
          nombre: 'Consulta Médica en Consultorio',
          clservicio: res.response.clservicio || servicio.clServicio,
          dsservicio: servicio.dsServicio || 'Asistencia Médica',
          clsubservicio: res.response.clsubservicio || servicio.clSubservicio,
          dssubservicio: servicio.dsSubServicio || 'Consulta Médica en Consultorio',
          clestatus: res.response.clestatus || '0',
          dsestatus: 'Abierto',
          fecharegistro: res.response.fecharegistro || new Date().toISOString()
        };
        
        if (solicitudData) {
          localStorage.removeItem('solicitudData');
        }
        
        const navigationExtras: NavigationExtras = {
          state: assistanceData,
          queryParams: assistanceData
        };
        
        this.router.navigate(['/solicitud/detalle/', expediente], navigationExtras).then(() => {
          setTimeout(() => {
            this.goToCall();
          }, 1000);
        });
      },
      error: (err) => {
        this.loader.hide();
        console.error('Error al generar expediente:', err);
      }
    });
  }

  private splitFullName(fullName: string) {
    const parts = fullName.trim().split(' ');
    return {
      firstName: parts[0] || '',
      lastName: parts[1] || '',
      secondLastName: parts.slice(2).join(' ') || ''
    };
  }

  isSelected(value: string): boolean {
    return this.selectedPatient === value;
  }

  goToAddDependent():void{
    this.router.navigate(['/add-dependiente'], { queryParams: { returnUrl: this.router.url } });
  }

  private getServiceContact(): void {
    try {
      const contacts = JSON.parse(localStorage.getItem('servicesContact') || '[]');
      const serviceContact = contacts.find((c: any) => 
        c.clServicio === 6 || c.clSubServicio === 383
      );
      this.contactoDeTelefono = serviceContact?.phone || '0';
    } catch {
      this.contactoDeTelefono = '0';
    }
  }

  goToCall() {
    if (this.contactoDeTelefono && this.contactoDeTelefono !== '0') {
      window.open(`tel:${this.contactoDeTelefono}`, '_self');
    }
  }
}
